import React from 'react'
import './projects.css'
import projects from '../../assets/projects'

const Projects = () => {

    return (<>

        <div className="projects-hero">
            <div className='page-title'>Top Projects</div>
            <div className="projects-container">

                {projects.map((project) => (

                    <div className="project">
                        <img src={project.imgurl} alt="Screenshot of Project" className='project-img' />
                        <div className="project-title">{project.title}</div>
                        <div className="project-desc">{project.desc}</div>
                        <div className="project-actions">
                            <a href={project.link} className="project-preview" target="_blank">Live Preview</a>
                            <a href={project.github} className="project-github" target="_blank">{project.github?"Check on Github":"Private Project"}</a>
                        </div>
                    </div>

                ))}

            </div>
        </div>

    </>
    )
}

export default Projects